import { createFileRoute } from '@tanstack/react-router';
import { DesktopTasksList } from '@/features/tasks/desktop/DesktopTasksList';

/*
 * L'elenco ha un indirizzo suo da quando `/tasks` apre l'Agenda.
 *
 * ⚠️ Su telefono questa rotta non viene montata: `MobileTasks` rende la Lista da sé (è la sua
 * vista predefinita, con ricerca e foglio dei filtri) e per le altre viste rende l'`Outlet`.
 */
export const Route = createFileRoute('/_app/tasks/list')({ component: DesktopTasksList });
